import React, { useState, useRef } from "react";

import axios from "axios";
import { Header } from "../components";
import { baseUrl } from "../data/baseURL";
import { useLocation } from "react-router-dom";

const Editor = () => {
  const { state } = useLocation();
  const [title, setTitle] = useState(state?.title ? state.title : "");
  const [landingImage, setLandingImage] = useState(null);
  const [description, setDescription] = useState(state?.description ? state.description : "");
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    setLandingImage(file); // Store the file directly
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleImageUpload(e);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Description", description);
    if (landingImage) {
      formData.append("Image", landingImage);
    }

    try {
      const response = await axios.post(`${baseUrl}/Requests`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      window.alert("پست با موفقیت ایجاد شد");
      setLoading(false);
    } catch (error) {
      console.error("Error submitting post:", error);
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Id", state.id);
    formData.append("Title", title);
    formData.append("Description", description);
    formData.append("Image", landingImage);

    try {
      await axios.put(`${baseUrl}/Requests`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      window.alert("پست با موفقیت ویرایش شد");
    } catch (error) {
      console.error("Error editing post:", error);
      setLoading(false);
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="App" title={state ? "ویرایش آیتم امانت " + state.id : "ایجاد آیتم امانت"} />

      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="عنوان"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div
        className="mb-4 border-dashed border-2 p-4 text-center cursor-pointer"
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <p>آپلود تصویر</p>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          ref={fileInputRef}
          className="hidden"
        />
        {landingImage && <p>{landingImage.name}</p>}
      </div>

      <div className="mb-4">
        <textarea
          className="w-full p-2 border rounded"
          placeholder="توصیحات"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="6"
        ></textarea>
      </div>



      <button
        className="bg-blue-500 text-white p-2 rounded"
        onClick={state ? handleEdit : handleSubmit}
        disabled={loading}
      >
        {loading ? "در حال ارسال..." : (state ? "ویرایش" : "ایجاد")}
      </button>
    </div>
  );
};

export default Editor;
